export default "__VITE_ASSET__46522a80__"